type EnvMap = Record<string, string | undefined>;

declare global {
    interface Window {
        __APP_ENV__?: EnvMap;
    }
}

const processEnv = typeof process !== 'undefined' && process.env && typeof process.env === 'object'
    ? (process.env as unknown as { APP_ENV?: EnvMap })
    : undefined;

const runtimeEnv = typeof window !== 'undefined' ? window.__APP_ENV__ : undefined;
const definedEnv = processEnv?.APP_ENV;

export const env: EnvMap = {
    ...(definedEnv ?? {}),
    ...(runtimeEnv ?? {}),
};
